import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

// ─────────────────────────────────────────────────────────────────────────
//  MobileMenuContext
//
//  Ajouté le 15/09/2026 — état partagé pour le menu mobile (tiroir de
//  navigation). Topbar.jsx (rendu par chaque page) et Sidebar.jsx (rendu une
//  seule fois par AppLayout.jsx) ne sont PAS parent/enfant dans l'arbre React
//  — ce contexte est le seul moyen propre pour que le bouton ☰ affiché dans
//  Topbar ouvre/ferme le tiroir géré par Sidebar, sans dupliquer un bouton
//  flottant qui se superposait au titre de la page.
//
//  Se ferme automatiquement au changement de page et si l'écran repasse en
//  desktop (> 768px), pour ne jamais rester ouvert dans un état incohérent.
// ─────────────────────────────────────────────────────────────────────────

const MobileMenuContext = createContext({
  isOpen: false,
  toggle: () => {},
  close:  () => {},
});

export const useMobileMenu = () => useContext(MobileMenuContext);

export function MobileMenuProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setIsOpen(false); }, [location.pathname]);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 768) setIsOpen(false); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const toggle = useCallback(() => setIsOpen(v => !v), []);
  const close  = useCallback(() => setIsOpen(false), []);

  return (
    <MobileMenuContext.Provider value={{ isOpen, toggle, close }}>
      {children}
    </MobileMenuContext.Provider>
  );
}
